import React from 'react';
import US, { Props } from './US';
import { title } from 'utils/storyUtils';

import colors from '../styles/colors';

interface Module {
  default: React.FunctionComponent;
}

export default {
  title: title('Flags'),
  component: US,
  parameters: {
    // disable automatic a11y check as the plugin nearly freezes your entire
    // browser trying to check these stories
    a11y: { manual: true },
  },
};

// @ts-ignore shortcut for dynamically loaded all flags from directory
function requireAll(requireContext): Module[] {
  return requireContext.keys().map(requireContext);
}

function loadFlags(): React.FC[] {
  return requireAll(require.context('.', false, /^\.\/[A-Za-z1-9]+\.tsx$/)).map(
    module => module.default,
  );
}

const Flags = (style: object) => (
  <div style={{ color: '#111', maxWidth: 250, ...style }}>
    {loadFlags().map(IconComponent => (
      <dl
        key={IconComponent.name}
        style={{
          columns: 2,
          margin: 0,
          paddingTop: '1em',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <dd
          style={{
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            padding: '0 24px 0 8px',
          }}
        >
          <IconComponent />
        </dd>
        <dt style={{ display: 'flex', alignItems: 'center' }}>
          <pre>
            {'<'}
            {IconComponent.displayName}
            {' />'}
          </pre>
        </dt>
      </dl>
    ))}
  </div>
);

export const Showcase = (props: Props) => Flags({});

export const BackgroundColorTest = (props: Props) =>
  Flags({ backgroundColor: colors.black200 });

export const SingleFlagTest = (props: Props) => <US />;
